module.exports = __webpack_public_path__ + "img/home_illustration_1.f3887553.svg";